import { useCallback } from "react";

import { cn } from "@/lib/chillnn/cn";

import type { ForNodeType } from "@/components/features/_model/types";
import type { SnackBlocksFormModelContentsMethodsType } from "@/components/features/snack/snack/settings/model/usecase/use-create-snack-layout-settings-form-model/methods/contents";

type Props = {
	uuid: ForNodeType<string> | undefined;
	onSetBlockLayoutType: SnackBlocksFormModelContentsMethodsType["onSetBlockLayoutType"];
};

export const SnackLayoutSettingsDialogDetailSelectLayout = ({ uuid, onSetBlockLayoutType }: Props) => {
	const handleClickColumn1 = useCallback(
		() => onSetBlockLayoutType({ layoutType: "column-1", targetUUID: uuid?.value ?? "" }),
		[onSetBlockLayoutType, uuid?.value],
	);

	const handleClickColumn2 = useCallback(
		() => onSetBlockLayoutType({ layoutType: "column-2", targetUUID: uuid?.value ?? "" }),
		[onSetBlockLayoutType, uuid?.value],
	);

	const handleClickColumn3 = useCallback(
		() => onSetBlockLayoutType({ layoutType: "column-3", targetUUID: uuid?.value ?? "" }),
		[onSetBlockLayoutType, uuid?.value],
	);

	return (
		<div className="space-y-6">
			<div
				role="button"
				className={cn("grid-cols-1 rounded border border-zinc-100 px-6 py-4 hover:bg-zinc-100")}
				onClick={handleClickColumn1}
			>
				<div className="col-span-1 h-20 rounded bg-zinc-300" />
			</div>
			<div
				role="button"
				className={cn(
					"grid grid-cols-2 gap-x-10 rounded border border-zinc-100 px-6 py-4 hover:bg-zinc-100", //
				)}
				onClick={handleClickColumn2}
			>
				<div className="col-span-1 h-20 rounded bg-zinc-300" />
				<div className="col-span-1 h-20 rounded bg-zinc-300" />
			</div>
			<div
				role="button"
				className={cn(
					"grid grid-cols-3 gap-x-6 rounded border border-zinc-100 px-6 py-4 hover:bg-zinc-100", //
				)}
				onClick={handleClickColumn3}
			>
				<div className="col-span-1 h-20 rounded bg-zinc-300" />
				<div className="col-span-1 h-20 rounded bg-zinc-300" />
				<div className="col-span-1 h-20 rounded bg-zinc-300" />
			</div>
		</div>
	);
};

SnackLayoutSettingsDialogDetailSelectLayout.displayName = "SnackLayoutSettingsDialogDetailSelectLayout";
